// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.

/* Code found before Ariq Co-op (useCustomEvents was false at this point)

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when a 'Enable hover add-to-cart' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
}); // This event fires whenever after additional collection items are
// added to the page due to filtering or click to load / infinite loading.

document.addEventListener("products:loaded", function () {
  console.log("Products loaded");
});

*/

/* ************************************************************************************* */
// ========================================
// B2B HOMEPAGE SCROLL ANIMATIONS
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  const heroContent = document.getElementById('hero-content-b2b');
  const contentSection = document.querySelector('.content-split-b2b');
  const heroBackground = document.querySelector('.hero-homepage-b2b__background');
  
  // Intersection Observer for content section fade-in
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);
  
  if (contentSection) {
    observer.observe(contentSection);
  }
  
  // Scroll event for hero fade out and parallax
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const windowHeight = window.innerHeight;
    // Start animation after scrolling 25% of viewport height instead of immediately
    const scrollProgress = Math.max(0, Math.min((scrolled - windowHeight * 0.30) / (windowHeight * 0.30), 1));
    
    if (heroContent) {
      // Fade out hero content as user scrolls (slower fade)
      const opacity = Math.max(1 - (scrollProgress * 1), 0);
      const translateY = scrollProgress * 75;
      
      heroContent.style.opacity = opacity;
      heroContent.style.transform = `translateY(${translateY}px)`;

      // Keep header logo always visible - MODIFIED LOGIC
      const headerLogo = document.querySelector('.header__logo');
      if (headerLogo) {
        // Always keep logo visible instead of showing/hiding based on opacity
        headerLogo.style.opacity = '1';
        headerLogo.style.visibility = 'visible';
        headerLogo.classList.add('visible');
      }
    }
    
    // Parallax effect for background
    if (heroBackground) {
      const parallaxSpeed = scrollProgress * 50;
      heroBackground.style.transform = `translateY(${parallaxSpeed}px)`;
    }
  });
  
  // Custom event for B2B homepage loaded
  const b2bHomepageEvent = new CustomEvent('b2b:homepage:loaded', {
    detail: {
      message: 'B2B Homepage animations initialized',
      timestamp: Date.now()
    }
  });
  document.dispatchEvent(b2bHomepageEvent);
});

// Listen for the custom B2B homepage event
document.addEventListener('b2b:homepage:loaded', function(evt) {
  console.log('B2B Homepage loaded:', evt.detail.message);
});
/* ************************************************************************************* */

/* ************************************************************************************* */
// ========================================
// PROCESS STEPS B2B SCROLL ANIMATIONS
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  const processSection = document.getElementById('process-steps-b2b');
  
  if (!processSection) return;
  
  let currentStep = 1;
  
  function showStep(stepNumber) {
    if (currentStep === stepNumber) return;
    
    currentStep = stepNumber;
    
    // Hide all steps and images
    document.querySelectorAll('.process-steps-b2b__step').forEach(step => {
      step.classList.remove('active');
    });
    
    document.querySelectorAll('.process-steps-b2b__image-container').forEach(image => {
      image.classList.remove('active');
    });
    
    // Show active step and image
    const activeStep = document.getElementById(`step-${stepNumber}`);
    const activeImage = document.getElementById(`image-${stepNumber}`);
    
    if (activeStep) activeStep.classList.add('active');
    if (activeImage) activeImage.classList.add('active');
  }
  
  // Simple scroll detection
  window.addEventListener('scroll', () => {
    const rect = processSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Only trigger when section is in viewport
    if (rect.top <= 0 && rect.bottom > viewportHeight) {
      const scrolledIntoSection = Math.abs(rect.top);
      const sectionHeight = processSection.offsetHeight - viewportHeight;
      const progress = scrolledIntoSection / sectionHeight;
      
      if (progress < 0.33) {
        showStep(1);
      } else if (progress < 0.66) {
        showStep(2);
      } else {
        showStep(3);
      }
    }
  });
  
  // Start with step 1
  showStep(1);
});
/* ************************************************************************************* */

/* ************************************************************************************* */
// ========================================
// SIMPLE CATEGORIES SHOWCASE TIMER
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  const categories = document.querySelectorAll('.categories-showcase-b2b__category');
  const dots = document.querySelectorAll('.categories-showcase-b2b__dot');
  
  if (categories.length === 0) return;
  
  let currentIndex = 0;
  
  function showCategory(index) {
    // Hide all categories
    categories.forEach(cat => {
      cat.classList.remove('active');
    });
    
    // Hide all dots
    dots.forEach(dot => {
      dot.classList.remove('active');
    });
    
    // Show current category and dot
    if (categories[index]) {
      categories[index].classList.add('active');
    }
    if (dots[index]) {
      dots[index].classList.add('active');
    }
  }
  
  function nextCategory() {
    currentIndex = (currentIndex + 1) % categories.length;
    showCategory(currentIndex);
  }
  
  // Start with first category
  showCategory(0);
  
  // Switch every 2 seconds
  setInterval(nextCategory, 2000);
});
/* ************************************************************************************* */

/* ************************************************************************************* */
// ========================================
// ANNOUNCEMENT BANNER CONTROL
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  const announcementBar = document.querySelector('.announcement-bar');
  
  if (announcementBar) {
    // Show only on product-related pages
    const showAnnouncementPages = [
      '/collections', // Collection pages
      '/products',    // Product pages
      '/cart',        // Cart page
      '/search'       // Search results page
    ];
    
    // Check if current path matches any product-related pages
    const shouldShowAnnouncement = showAnnouncementPages.some(page => 
      currentPath.includes(page)
    ) || currentPath === '/'; // Also show on homepage if needed
    
    if (shouldShowAnnouncement) {
      announcementBar.style.display = 'block';
    } else {
      // Hide on all other pages (blogs, about, contact, etc.)
      announcementBar.style.display = 'none';
    }
  }
});
/* ************************************************************************************* */

/* ************************************************************************************* */
// ========================================
// BRAND COLOR CONSISTENCY
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  // Ensure brand color consistency across all elements
  const brandColor = '#800020';
  
  // Update any dynamic elements that might need the brand color
  const brandElements = document.querySelectorAll('.hero-homepage-b2b__cta');
  
  brandElements.forEach(element => {
    if (element.classList.contains('hero-homepage-b2b__cta')) {
      element.style.backgroundColor = brandColor;
    }
  });
  
  // Ensure header logo image is always crisp
  const logoImages = document.querySelectorAll('.header__logo img, .hero-homepage-b2b__logo img');
  logoImages.forEach(img => {
    img.style.imageRendering = 'crisp-edges';
    img.style.webkitFontSmoothing = 'antialiased';
    img.style.mozOsxFontSmoothing = 'grayscale';
  });
});
/* ************************************************************************************* */

/* There are other JS scripts that are local to the B2B files */